export const url = "https://fooddeliveryappbackend-ahzn.onrender.com";
